import { DOCUMENT, NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';

export interface SkipLinkComponentBindings {
	options: SkipLinkOption[];
}

export interface SkipLinkOption {
	id: string;
	linkText: string;
	domElement?: HTMLElement;
}

@Component({
	selector: 'accessibility-skip-links',
	standalone: true,
	imports: [NgIf, NgFor],
	templateUrl: './skip-links.component.html',
	styleUrls: ['./skip-links.component.scss']
})
export class SkipLinksComponent implements OnInit, OnDestroy, SkipLinkComponentBindings {
	@Input() public options: SkipLinkOption[];
	public domObserver: MutationObserver;

	constructor (
		@Inject('Window') private window: Window,
		@Inject(DOCUMENT) private document: Document
	) {}

	public ngOnInit () {
		this.domObserver = new this.window.MutationObserver(this.onDomChange);
		this.domObserver.observe(this.document.body, {
			subtree: true,
			childList: true
		});
	}

	public ngOnDestroy () {
		this.domObserver.disconnect();
	}

	private onDomChange = () => {
		this.options.forEach((option) => {
			option.domElement = this.document.getElementById(option.id);
		});
	};
}
